import type { GarmentMarkersType } from 'src/types/decorationSpecs';

export type SizeType = { width: number; height: number };

/**
 * Sensible starting marker positions (in background-image pixel space) for a photo that hasn't
 * been calibrated yet, so a designer adjusts plausible points rather than starting from
 * stacked/zeroed ones. Loosely modeled on a typical front-on flat-lay T-shirt photo: shoulders
 * near the top, hem near the bottom, body width measured a bit above center, collar just below
 * the very top.
 */
export function defaultMarkers(natural: SizeType): GarmentMarkersType {
    return {
        leftX: natural.width * 0.25,
        rightX: natural.width * 0.75,
        measureY: natural.height * 0.45,
        shoulderTopY: natural.height * 0.1,
        collarBottomY: natural.height * 0.18,
        garmentBottomY: natural.height * 0.9,
    };
}
